import { ZcVersionCalcProcessSettingsComponent } from './components/dialogs/app-zc-version-calc-process-settings-dialog/app-zc-version-calc-process-settings-dialog.component';
import { ProcessDetailsViewTabComponent } from './components/process-detail-view-tab/process-details-view-tab.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { InstanceRoutingModule } from './instance-routing.module';
import { MaterialModule } from '../../shared/modules';

import { InstanceComponent } from './instance.component';
import { InstanceViewComponent, PropertyRecordsTabComponent, ZoningCodesViewComponent } from './components';
import { ZoningCodeDialogComponent } from './components/zoning-codes-view/zoning-code-dialog/zoning-code-dialog.component';
import { TaskViewComponent } from './components/task-view/task-view.component';
import { JobsTabComponent } from './components/jobs-tab/jobs-tab.component';
import { TasksComponent } from './components/tasks/tasks.component';

import { ValidateParamsGuard } from '../../shared/guards';
import { AddJobDialogComponent } from './components/jobs-tab/add-job-dialog/add-job-dialog.component';
import { MultistepProcessDetailsViewComponent } from './components/jobs-tab/multistep-process-details-view/multistep-process-details-view.component';
import { CalculationParametersInfoComponent } from './components/property-records-tab/calculation-parameters-info/calculation-parameters.component';
import { CalculateFolioSubformComponent } from './components/jobs-tab/add-job-dialog/calculate-folio-subform/calculate-folio-subform.component';
import { ZoningCodeSubformComponent } from './components/jobs-tab/add-job-dialog/zoning-code-subform/zoning-code-subform.component';
import { FileSaverModule } from 'ngx-filesaver';
import { SharedModule } from 'src/app/shared';
import { httpInterceptorProviders } from '../../shared/interceptors';
import {
    zoningCodeVersionCalculateButtonComponent,
    zoningCodeVersionRecalculateButtonComponent,
    zoningCodeVersionCheckStatusButtonComponent,
    zoningCodeVersionDeleteButtonComponent
} from './components/zoning-codes-view/zoning-code-version-buttons';
import { ZoningCodeService, ZoningCodeVersionService } from './services';
import { ZoningCodeVersionStatisticTabComponent } from './components/zoning-codes-view/zoning-code-version-details/zoning-code-version-tabs';
import { ZoningCodeVersionDataTabComponent } from './components/zoning-codes-view/zoning-code-version-details/zoning-code-version-tabs';
// import { ImportNewIdsSubformComponent } from './components/jobs-tab/add-job-dialog/import-new-ids-subform/import-new-ids-subform.component';
import { ZoningCodeReindexButtonComponent } from './components/zoning-codes-view/zoning-code-buttons/zoning-code-reindex-button/zoning-code-reindex-button.component';
import { zoningCodeCheckStatusButtonComponent } from './components/zoning-codes-view/zoning-code-buttons/zoning-code-check-status-button/zoning-code-check-status-button.component';
import { ZoningCodeIndexButtonComponent } from './components/zoning-codes-view/zoning-code-buttons/zoning-code-index-button/zoning-code-index-button.component';
import { zoningCodeDeleteButtonComponent } from './components/zoning-codes-view/zoning-code-buttons/zoning-code-delete-button/zoning-code-delete-button.component';
import { zoningCodeCheckVersionButtonComponent } from './components/zoning-codes-view/zoning-code-buttons/zoning-code-check-version-button/zoning-code-check-version-button.component';
import { zoningCodeVersionsDetailsComponent } from './components/zoning-codes-view/zoning-code-version-details/zoning-code-version-details.component';
import { RecalculateByStatusComponent } from './components/jobs-tab/add-job-dialog/recalculate-by-status/recalculate-by-status.component';
import { TypologySubformComponent } from './components/jobs-tab/add-job-dialog/typology-subform/typology-subform.component';
import { RestartProcessButtonComponent, ConfigureProcessButtonComponent } from './components/processes';
import { InstanceMonitoringTableComponent } from './components/instance-monitoring/instance-monitoring-table/instance-monitoring-table.component';
import { CdkColumnDef } from '@angular/cdk/table';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { IMUnsynchronizedCRGroupIdsRowComponent } from './components/instance-monitoring/i-m-unsynchronized-cr-group-ids-row/i-m-unsynchronized-cr-group-ids-row.component';
import { LabeledActionButtonComponent } from './components/action-buttons/labeled-action-button/labeled-action-button.component';
import { SchedulerPageComponent } from './components/scheduler-page/scheduler-page.component';
import { SchedulerModule } from '../scheduler/scheduler.module';
import { ZCDetailsViewComponent } from './components/zoning-codes-view/entity-details-view/zc-details-view/zc-details-view.component';
import { ZCIndexingProcessDetailsViewComponent } from './components/process-details-view/zc-indexing-process-details-view/zc-indexing-process-details-view.component';
import { ProcessDetailsViewComponent } from './components/process-details-view/process-details-view/process-details-view.component';
import { ZCVCalcProcessDetailsViewComponent } from './components/process-details-view/zcv-calc-process-details-view/zcv-calc-process-details-view.component';
import { ZCVersionDetailsViewComponent } from './components/zoning-codes-view/entity-details-view/zc-version-details-view/zc-version-details-view.component';
import { PrThreadsListComponent } from './components/process-details-view/pr-threads-list/pr-threads-list.component';
import { PrThreadRowComponent } from './components/process-details-view/pr-thread-row/pr-thread-row.component';
import { StopAllProcessesButtonComponent } from './components/processes/buttons/stop-all-processes-button/stop-all-processes-button.component';
import { MakeProcessIdleButtonComponent } from './components/processes/buttons/make-process-idle-button/make-process-idle-button.component';
import { SynchronizationModule } from '../synchronization/synchronization.module';
import { ProcessesStatusComponent } from './components/processes/processes-status/processes-status.component';
import { RemoveSelectedProcessesComponent } from './components/processes/buttons/remove-selected-processes/remove-selected-processes.component';
import { ArchiveSelectedProcessesComponent } from './components/processes/buttons/archive-selected-processes/archive-selected-processes.component';
import { ActiveJobActionsComponent } from './components/jobs-tab/active-job-actions/active-job-actions.component';
import { ArchivedJobActionsComponent } from './components/jobs-tab/archived-job-actions/archived-job-actions.component';
import { RemoveProcessButtonComponent } from './components/action-buttons/remove-process-button/remove-process-button.component';
import { CheckProcessButtonComponent } from './components/action-buttons/check-process-button/check-process-button.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { PaginatedJobsListComponent } from './components/paginated-jobs-list/paginated-jobs-list.component';
import { TaskCalcProcessDetailViewComponent } from './components/process-detail-view-tab/task-process-detail-view/task-process-detail-view.component';
import { JobProcessDetailsViewComponent } from './components/process-detail-view-tab/job-process-details-view/job-process-details-view.component';
import { ShowTaskTabButtonComponent } from './components/action-buttons/show-task-tab-button/show-task-tab-button.component';
import { ZoningCodeReindexWithCursorButtonComponent } from './components/zoning-codes-view/zoning-code-buttons/zoning-code-reindex-with-cursor-button/zoning-code-reindex-with-cursor-button.component';
import { ZoningCodeViewComponent } from './components/zoning-code-view/zoning-code-view.component';
import { ZoningCodeVersionsListComponent } from './components/zoning-code-versions-list/zoning-code-versions-list.component';
import { TasksListComponent } from './components/tasks-list/tasks-list.component';
import { TaskPerformanceDetailsComponent } from './components/process-detail-view-tab/task-performance-details/task-performance-details.component';
import { ZcPerformanceDetailsViewComponent } from './components/zoning-codes-view/entity-details-view/zc-performance-details-view/zc-performance-details-view.component';
import { UpdateInstanceStatisticButtonComponent } from './components/action-buttons/update-instance-statistic-button/update-instance-statistic-button.component';
import { IMLastUpdatedRowComponent } from './components/instance-monitoring/i-m-last-updated-row/i-m-last-updated-row.component';
import { PrsBunchSizeSliderComponent } from './components/process-details-view/prs-bunch-size-slider/prs-bunch-size-slider.component';
import { ShowProcessDetailsPopupButtonComponent } from './components/processes/buttons/show-process-details-popup-button/show-process-details-popup-button.component';
import { ZoningCodeStatusesListComponent } from './components/zoning-code-statuses-list/zoning-code-statuses-list.component';
import { UpdateZcStatusButtonComponent } from './components/action-buttons/update-zc-status-button/update-zc-status-button.component';
import { MatGridListModule } from '@angular/material/grid-list';
import { UpdateProcessPerfStatButtonComponent } from './components/action-buttons/update-process-perf-stat-button/update-process-perf-stat-button.component';
import { FileChooserSubformComponent } from './components/jobs-tab/add-job-dialog/file-chooser-subform/file-chooser-subform.component';
import { ReplaceLandUseIdsDetailsViewComponent } from './components/replace-land-use-ids-details-view/replace-land-use-ids-details-view.component';
import { ProcessStatisticSectionComponent } from './components/processes/sections/process-statistic-section/process-statistic-section.component';
import { ProcessStatsByStatusSectionComponent } from './components/processes/sections/process-stats-by-status-section/process-stats-by-status-section.component';
import { ProcessMessagesSectionComponent } from './components/processes/sections/process-messages-section/process-messages-section.component';
import { ReplaceLandUseIdsListComponent } from './components/processes/sections/replace-land-use-ids-list/replace-land-use-ids-list.component';
import { ReplaceLandUseIdsRowComponent } from './components/processes/sections/replace-land-use-ids-row/replace-land-use-ids-row.component';
import { ReplaceLandUseIdStatisticSectionComponent } from './components/processes/sections/replace-land-use-id-statistic-section/replace-land-use-id-statistic-section.component';
import { ReplaceLandUseIdsGeneralStatisticComponent } from './components/processes/sections/replace-land-use-ids-general-statistic/replace-land-use-ids-general-statistic.component';
import { SetZcVersionLastUpdatedButtonComponent } from './components/action-buttons/set-zc-version-last-updated-button/set-zc-version-last-updated-button.component';
import { SetZcVersionPropertiesDialogComponent } from './components/dialogs/set-zc-version-properties-dialog/set-zc-version-properties-dialog.component';
import { ZoningCodeVersionCalculateWithSettingsButtonComponent } from './components/zoning-codes-view/zoning-code-version-buttons/zoning-code-version-calculate-with-settings-button/zoning-code-version-calculate-with-settings-button.component';
import { ZoningCodeVersionRecalculateWithSettingsButtonComponent } from './components/zoning-codes-view/zoning-code-version-buttons/zoning-code-version-recalculate-with-settings-button/zoning-code-version-recalculate-with-settings-button.component';
import { ProcessCacheStatisticComponent } from './components/process-detail-view-tab/process-cache-statistic/process-cache-statistic.component';
import { ProcessDetailsViewCalcPrMultiThreadComponent } from './components/process-details-view/process-details-view-calc-pr-multi-thread/process-details-view-calc-pr-multi-thread.component';
import { ProcessStatisticSelectionCalcPrMultiThreadComponent } from './components/processes/sections/process-statistic-selection-calc-pr-multi-thread/process-statistic-selection-calc-pr-multi-thread.component';
import { ProcessGisDataCacheIteratorStatisticComponent } from './components/process-detail-view-tab/process-gis-data-cache-iterator-statistic/process-gis-data-cache-iterator-statistic.component';
import { ProcessGisDataCacheStatisticComponent } from './components/process-detail-view-tab/process-gis-data-cache-statistic/process-gis-data-cache-statistic.component';
import { ProcessEventsListComponent } from './components/process-details-view/process-events-list/process-events-list.component';
import { ProcessEventRowComponent } from './components/process-details-view/process-event-row/process-event-row.component';
import { UpdateSystemEventsListButtonComponent } from './components/action-buttons/update-system-events-list-button/update-system-events-list-button.component';
import { ZoningCodeEventsListComponent } from './components/zoning-code-view/zoning-code-events-list/zoning-code-events-list.component';
import { ZoningCodeEventRowComponent } from './components/zoning-code-view/zoning-code-event-row/zoning-code-event-row.component';
import { UpdateProcessEventsStatisticButtonComponent } from './components/processes/buttons/update-process-events-statistic-button/update-process-events-statistic-button.component';
import { EventsStatComponentComponent } from './components/processes/sections/events-stat-component/events-stat-component.component';
import { PrsMissedEntitiesViewComponent } from './components/prs-missed-entities-view/prs-missed-entities-view.component';
import { UpdateZcvStatusButtonComponent } from './components/action-buttons/update-zcv-status-button/update-zcv-status-button.component';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { EventsStatHintIconComponent } from './components/processes/sections/events-stat-hint-icon/events-stat-hint-icon.component';
import { MissedEntitiesDetailsIconComponent } from './components/missed-entities-details-icon/missed-entities-details-icon.component';
import { ClearProcessThreadsButtonComponent } from './components/processes/buttons/clear-process-threads-button/clear-process-threads-button.component';
import { ZoningCodePrCrStatisticComponent } from './components/zoning-code-pr-cr-statistic/zoning-code-pr-cr-statistic.component';
import { ZcPrsStatisticComponent } from './components/zoning-codes-view/entity-details-view/zc-prs-statistic/zc-prs-statistic.component';
import { DataSourceCategorySubformComponent } from './components/jobs-tab/add-job-dialog/data-source-category-subform/data-source-category-subform.component';
import { SolrGroupIdsDataStatisticComponent } from './components/process-detail-view-tab/solr-group-ids-data-statistic/solr-group-ids-data-statistic.component';
import { ZoningCodeVersionsAuStatisticComponent } from './components/zoning-code-versions-au-statistic/zoning-code-versions-au-statistic.component';
import { ZcVersionSelectSubformComponent } from './components/jobs-tab/add-job-dialog/zc-version-select-subform/zc-version-select-subform.component';
import { RemoveZcJobProcessDetailsViewComponent } from './components/process-details-view/remove-zc-job-process-details-view/remove-zc-job-process-details-view.component';
import { SolrOperationsStatusComponent } from './components/process-detail-view-tab/solr-operations-status/solr-operations-status.component';
import { BulkOperationStatisticComponent } from './components/process-detail-view-tab/bulk-operation-statistic/bulk-operation-statistic.component';
import { ZcIndexingProcessSettingsDialogComponent } from './components/dialogs/zc-indexing-process-settings-dialog/zc-indexing-process-settings-dialog.component';
import { ProcessStatusRowComponent } from './components/processes/sections/process-status-row/process-status-row.component';
import { ProcessTaskItemsListComponent } from './components/process-details-view/process-task-items-list/process-task-items-list.component';
import { PaginatedProcessTaskItemsListComponent } from './components/process-details-view/paginated-process-task-items-list/paginated-process-task-items-list.component';
import { PaginatedProcessListComponentComponent } from './components/process-details-view/paginated-process-list-component/paginated-process-list-component.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        InstanceRoutingModule,
        MaterialModule,
        FileSaverModule,
        SharedModule,
        SchedulerModule,
        SynchronizationModule,
        MatPaginatorModule,
        MatGridListModule,
        ClipboardModule,
        PopoverModule
    ],
    declarations: [
        InstanceComponent,
        InstanceViewComponent,
        PropertyRecordsTabComponent,
        ZoningCodesViewComponent,
        ZoningCodeDialogComponent,
        AddJobDialogComponent,
        MultistepProcessDetailsViewComponent,
        CalculationParametersInfoComponent,
        CalculateFolioSubformComponent,
        ZoningCodeSubformComponent,
        TaskViewComponent,
        JobsTabComponent,
        TasksComponent,
        zoningCodeVersionsDetailsComponent,
        zoningCodeVersionCalculateButtonComponent,
        zoningCodeVersionRecalculateButtonComponent,
        zoningCodeVersionCheckStatusButtonComponent,
        zoningCodeVersionDeleteButtonComponent,
        ZoningCodeReindexButtonComponent,
        zoningCodeCheckStatusButtonComponent,
        ZoningCodeIndexButtonComponent,
        zoningCodeDeleteButtonComponent,
        zoningCodeCheckVersionButtonComponent,
        ProcessDetailsViewComponent,
        ZCIndexingProcessDetailsViewComponent,
        ZCVCalcProcessDetailsViewComponent,
        ZCDetailsViewComponent,
        ZCVersionDetailsViewComponent,
        ZoningCodeVersionStatisticTabComponent,
        ZoningCodeVersionDataTabComponent,
        // ImportNewIdsSubformComponent,
        RecalculateByStatusComponent,
        TypologySubformComponent,
        RestartProcessButtonComponent,
        ConfigureProcessButtonComponent,
        InstanceMonitoringTableComponent,
        IMUnsynchronizedCRGroupIdsRowComponent,
        LabeledActionButtonComponent,
        SchedulerPageComponent,
        PrThreadsListComponent,
        PrThreadRowComponent,
        StopAllProcessesButtonComponent,
        MakeProcessIdleButtonComponent,
        ProcessesStatusComponent,
        RemoveSelectedProcessesComponent,
        ArchiveSelectedProcessesComponent,
        ActiveJobActionsComponent,
        ArchivedJobActionsComponent,
        RemoveProcessButtonComponent,
        CheckProcessButtonComponent,
        PaginatedJobsListComponent,
        ProcessDetailsViewComponent,
        TaskCalcProcessDetailViewComponent,
        ProcessDetailsViewTabComponent,
        JobProcessDetailsViewComponent,
        ShowTaskTabButtonComponent,
        ZoningCodeReindexWithCursorButtonComponent,
        ZoningCodeViewComponent,
        ZoningCodeVersionsListComponent,
        TasksListComponent,
        TaskPerformanceDetailsComponent,
        ZcPerformanceDetailsViewComponent,
        UpdateInstanceStatisticButtonComponent,
        IMLastUpdatedRowComponent,
        PrsBunchSizeSliderComponent,
        ShowProcessDetailsPopupButtonComponent,
        ZoningCodeStatusesListComponent,
        UpdateZcStatusButtonComponent,
        UpdateProcessPerfStatButtonComponent,
        FileChooserSubformComponent,
        ProcessStatisticSectionComponent,
        ProcessStatsByStatusSectionComponent,
        ProcessMessagesSectionComponent,
        ReplaceLandUseIdsDetailsViewComponent,
        ReplaceLandUseIdsListComponent,
        ReplaceLandUseIdsRowComponent,
        ReplaceLandUseIdStatisticSectionComponent,
        ReplaceLandUseIdsGeneralStatisticComponent,
        SetZcVersionLastUpdatedButtonComponent,
        SetZcVersionPropertiesDialogComponent,
        ZcVersionCalcProcessSettingsComponent,
        ZoningCodeVersionCalculateWithSettingsButtonComponent,
        ZoningCodeVersionRecalculateWithSettingsButtonComponent,
        ProcessCacheStatisticComponent,
        ProcessDetailsViewCalcPrMultiThreadComponent,
        ProcessStatisticSelectionCalcPrMultiThreadComponent,
        ProcessGisDataCacheIteratorStatisticComponent,
        ProcessGisDataCacheStatisticComponent,
        ProcessEventsListComponent,
        ProcessEventRowComponent,
        UpdateSystemEventsListButtonComponent,
        ZoningCodeEventsListComponent,
        ZoningCodeEventRowComponent,
        UpdateProcessEventsStatisticButtonComponent,
        EventsStatComponentComponent,
        PrsMissedEntitiesViewComponent,
        UpdateZcvStatusButtonComponent,
        EventsStatHintIconComponent,
        MissedEntitiesDetailsIconComponent,
        ClearProcessThreadsButtonComponent,
        ZoningCodePrCrStatisticComponent,
        ZcPrsStatisticComponent,
        DataSourceCategorySubformComponent,
        SolrGroupIdsDataStatisticComponent,
        ZoningCodeVersionsAuStatisticComponent,
        ZcVersionSelectSubformComponent,
        RemoveZcJobProcessDetailsViewComponent,
        SolrOperationsStatusComponent,
        BulkOperationStatisticComponent,
        ZcIndexingProcessSettingsDialogComponent,
        ProcessStatusRowComponent,
        ProcessTaskItemsListComponent,
        PaginatedProcessTaskItemsListComponent,
        PaginatedProcessListComponentComponent
    ],
    providers: [
        ValidateParamsGuard,
        httpInterceptorProviders,
        ZoningCodeService,
        ZoningCodeVersionService,
        CdkColumnDef
    ],
    exports: [JobsTabComponent, ProcessesStatusComponent, PaginatedProcessListComponentComponent]
})
export class InstanceModule {}
